import {Message} from "element-ui"
import CryptoJS from 'crypto-js'
import {isMobile} from 'react-device-detect';

export function base64ImgtoFile (dataUrl, filename = 'file') {
  let arr = dataUrl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]

  let decodeBase64 = atob(arr[1])
  let len = decodeBase64.length
  let uint8Array = new Uint8Array(len)
  while (len--) {
    uint8Array[len] = decodeBase64.charCodeAt(len)
  }
  return new File([uint8Array], `${filename}.${suffix}`, {type: mime})
}

export function filetoBase64Img (file) {
  return new Promise(function(resolve, reject) {
    let reader = new FileReader()
    let imgResult = ""
    reader.readAsDataURL(file)
    reader.onload = function() {
      imgResult = reader.result
    }
    reader.onerror = function(error) {
      reject(error)
    }
    reader.onloadend = function() {
      resolve(imgResult)
    }
  })
}

export const validateLicense = (rule, value, callback) => {
  if(value.length !== 18){
    callback(new Error('证件号码长度错误！'))
  }
  const reg = /^([159Y]{1})([1239]{1})([0-9]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-9ABCDEFGHJKLMNPQRTUWXY]{1})$/;
  if(!reg.test(value)){
    callback(new Error('证件号码校验错误！'))
  }
  //不用I、O、S、V、Z
  const str = '0123456789ABCDEFGHJKLMNPQRTUWXY'
  const ws =[1,3,9,27,19,26,16,17,20,29,25,13,8,24,10,30,28];

  let codes = []
  let sum = 0;
  codes[0] = value.substr(0, value.length-1);
  codes[1] = value.substr(value.length-1, value.length);

  for(let i=0;i<codes[0].length;i++){
    let Ancode = codes[0].charAt(i);
    let Ancodevalue = str.indexOf(Ancode);
    sum += Ancodevalue * ws[i];
  }
  let indexOfc18 = 31 - (sum % 31);
  if(str.charAt(indexOfc18) !== codes[1]){
    callback(new Error('证件号码校验错误！'))
  }
  callback()
}

export const validateCard = (rule, value, callback) => {
  const arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
  const arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
  if (value === '') {
    callback(new Error('请输入正确的证件号码'))
  } else if (/^\d{17}\d|x$/i.test(value)) {
    let sum = 0
    for(let i = 0; i < value.length - 1; i++){
      // 对前17位数字与权值乘积求和
      sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
    }
    // 检验第18为是否与校验码相等
    if (String(arrValid[sum % 11]) === value.substr(17, 1).toUpperCase()) {
      callback()
    }
  }
  callback(new Error('请输入正确的证件号码'))
}

export const validateContact = (rule, value, callback) => {
  const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/
  if (regEmail.test(value) || regMobile.test(value)) {
    callback()
  } else {
    callback(new Error('请输⼊正确的⼿机号'))
  }
}

export const validatePass = (rule, value, callback) => {
  const reg = new RegExp("[\x20-\x7E]{6,64}","g")
  const reg2 = new RegExp(/\s+/g)

  if (reg.test(value) && !reg2.test(value)) {
    callback()
  } else {
    callback(new Error('密码格式错误，密码需长度为6-64位且不带空格'))
  }
}

export function notify (notify_type, notify_msg) {
  /**
   * @description notify_type: success, warning, error
   */
  Message({
    message: notify_msg ? notify_msg : '未知错误',
    type: notify_type,
    duration: 3000,
    showClose: true
  })
}

export function getUUID () {
  //获取系统当前的时间
  let d = new Date().getTime()
  //替换uuid里面的x和y
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    //取余 16进制
    const r = (d + Math.random() * 16) % 16 | 0
    //向下取整
    d = Math.floor(d / 16)
    //toString 表示编程16进制的数据
    return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
  })
}

export function getAppType () {
  if (window.matchMedia("only screen and (max-width: 760px)").matches || window.matchMedia("(pointer:coarse)").matches || window.matchMedia("(any-pointer:coarse)").matches) {
    return "CERTIFICATION_MOBILE"
  }
  return "CERTIFICATION_PC"
}

export function getAccountType (accountName) {
  const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  return regEmail.test(accountName) ? 0 : 1
}

export function randomString (length, chars) {
  let result = ''
  for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
  return result
}

export function getSignature (params, path) {
  params = params ? params : {}
  const ackey = "1245878547"

  // 实体的MD5加密
  const md5 = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(params.toString())).toString(CryptoJS.enc.Base64)
  // 当前时间
  let Timestamp = new Date().getTime()
  // 任意数字
  const nonce = randomString(20, '0123456789');
  let authStr = "Timestamp=" + Timestamp.toString() + ", Nonce=" + nonce + ", AccessKey=" + ackey
  // 需要计算签名的字符
  const str = md5 + "&" + Timestamp.toString() + "&" + nonce + "&" + path
  // 秘钥
  let salt = "zLa4PxbcQRGfd~RqpnD2gtN#ekSg5CHpY#oz%N9KUE#YnEy*n(!xyDnVVkACQcZLlInZaN)GhKrxO$susnH$+LPIuQl6TM7_9UDEPbJQ)uguzgF*rbA3n8_*pehdQiBX"
  const hash = CryptoJS.HmacSHA1(str, salt)
  // 头部 X-Authorization
  authStr = authStr + ", Signature=" + hash.toString(CryptoJS.enc.Hex)
  console.log('md5: ', md5, 'authStr: ', authStr)
  return { cmd5: md5, authStr: authStr }
}
